module.exports = __webpack_public_path__ + "static/media/sad-tear.3a7e50de.svg";